// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__hZJQ1","label":"styles_label__qWSbT","valueWrapper":"styles_valueWrapper__qiH6T","value":"styles_value__kzcdF","measure":"styles_measure__o3GBX"};